/**
 * Common Feature Structure
 * Defines the standard structure for feature data
 */

const CommonFeatureStructure = {
    featureList: [
      {
        featureId: "", // Unique Feature ID (number)
        featureUuid: "", // UUID for feature
        featureName: "", // Feature name (e.g., "LS", "CD")
        featureCode: "", // Feature code (same as featureName)
        title: "", // Display title
        description: "", // Feature description
        image: "", // Feature image path
        videoUrl: "", // Video URL for feature demo
        createdOn: "", // ISO 8601 date string
        createdBy: "", // Creator name
        category: "", // Feature category
        isDefault: false, // Boolean - is this a default feature
      }
    ]
  };
  
  export default CommonFeatureStructure;